import React from "react";
import MemberPhoto from "~/src/components/member-photo";
import Stars from "~/src/components/stars";
import {
  Wrapper,
  StarsWrapper,
  LightText,
  ShouldShowContainer
} from "./member.styles";

export default function Member(props) {
  return (
    <Wrapper onClick={props.showMemberModal} onKeyDown={props.showMemberModal}>
      <MemberPhoto
        isInline
        src={props.member.photo}
        poolType={props.member.relationship.poolType}
      />
      <StarsWrapper>
        <Stars isEditable={false} value={props.member.rating} isSmall />
      </StarsWrapper>
      {props.member.firstName} {props.member.lastName}
      <LightText>
        <ShouldShowContainer shouldNotShow>
          {props.member.bookingsCount.allPreviouslyAccepted} shifts completed
        </ShouldShowContainer>
        <div>
          {props.member.bookingsCount.previouslyAccepted} shifts with you
        </div>
      </LightText>
    </Wrapper>
  );
}
